/* THAYA · product.js — PDP interactions (gallery, variants, fit mode, delivery, modals) */
(function () {
  var pdp = document.querySelector('[data-pdp]');
  if (!pdp) return;

  var form = document.getElementById('thayaProductForm');
  var variants = [];
  try { variants = JSON.parse(document.querySelector('[data-product-json]').textContent); } catch (e) {}
  var moneyFormat = '${{amount}}';
  try { moneyFormat = JSON.parse(document.querySelector('[data-money-format]').textContent); } catch (e) {}

  function money(cents) {
    var v = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return moneyFormat.replace(/\{\{\s*amount(_no_decimals)?\s*\}\}/, v).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v).replace(/<[^>]+>/g, '');
  }

  /* ---------- gallery ---------- */
  var mainImg = document.getElementById('thayaMainImg');
  var stage = document.getElementById('thayaStage');
  var thumbs = pdp.querySelectorAll('#thayaThumbs button');
  thumbs.forEach(function (b) {
    b.addEventListener('click', function () {
      thumbs.forEach(function (x) { x.classList.remove('is-active'); });
      b.classList.add('is-active');
      if (!mainImg) return;
      var src = b.getAttribute('data-full');
      if (!src) { var im = b.querySelector('img'); src = im ? im.src : ''; }
      mainImg.style.opacity = 0;
      setTimeout(function () {
        mainImg.removeAttribute('srcset'); // srcset would otherwise override src
        mainImg.removeAttribute('sizes');
        mainImg.src = src;
        mainImg.style.opacity = 1;
        stage.classList.remove('is-zoomed');
        mainImg.style.transform = '';
      }, 150);
    });
  });
  if (stage && mainImg) {
    stage.addEventListener('click', function (e) {
      if (stage.classList.toggle('is-zoomed')) {
        var r = stage.getBoundingClientRect();
        mainImg.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        mainImg.style.transform = 'scale(1.9)';
      } else { mainImg.style.transform = ''; }
    });
    stage.addEventListener('mousemove', function (e) {
      if (!stage.classList.contains('is-zoomed')) return;
      var r = stage.getBoundingClientRect();
      mainImg.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
    });
  }

  /* ---------- variant selection ---------- */
  var OPTSEL = '.t-opt__btn, .t-swatch';
  var selected = [];
  pdp.querySelectorAll('.t-opt').forEach(function (opt, i) {
    var active = opt.querySelector('.t-opt__btn.is-active, .t-swatch.is-active');
    var first = opt.querySelector(OPTSEL);
    selected[i] = active ? active.dataset.value : (first ? first.dataset.value : null);
    opt.querySelectorAll(OPTSEL).forEach(function (btn) {
      btn.addEventListener('click', function () {
        opt.querySelectorAll(OPTSEL).forEach(function (x) { x.classList.remove('is-active'); });
        btn.classList.add('is-active');
        selected[i] = btn.dataset.value;
        var lbl = opt.querySelector('[data-opt-value]');
        if (lbl) lbl.textContent = btn.dataset.value;
        updateVariant();
      });
    });
  });

  function currentVariant() {
    return variants.find(function (v) {
      return (v.options || []).every(function (o, idx) { return String(o) === String(selected[idx]); });
    });
  }

  function updateVariant() {
    var v = currentVariant();
    var idInput = form.querySelector('[data-variant-id]');
    var atc = pdp.querySelector('[data-atc]');
    if (!v) return;
    if (idInput) idInput.value = v.id;
    pdp.querySelectorAll('[data-price]').forEach(function (el) { el.textContent = money(v.price); });
    var cmp = pdp.querySelector('[data-compare]');
    if (cmp) cmp.style.display = (v.compare_at_price > v.price) ? '' : 'none';
    if (atc && atc.dataset.atcTpl) {
      atc.disabled = !v.available;
      atc.textContent = v.available ? atc.dataset.atcTpl.replace('%price%', money(v.price)) : atc.dataset.soldout;
    } else if (atc) {
      atc.disabled = !v.available;
    }
  }

  /* ---------- qty ---------- */
  var qtyInput = pdp.querySelector('[data-qty-input]');
  pdp.querySelectorAll('[data-qty]').forEach(function (b) {
    b.addEventListener('click', function () {
      var n = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(b.dataset.qty, 10));
      qtyInput.value = n;
    });
  });

  /* ---------- add to cart ---------- */
  function submitAdd(e) {
    if (e) e.preventDefault();
    // "Often bought together" — extras the shopper ticked
    var extras = [].slice.call(pdp.querySelectorAll('[data-fbt-variant]'))
      .filter(function (c) { return c.checked; })
      .map(function (c) { return { id: parseInt(c.dataset.fbtVariant, 10), quantity: 1 }; });

    if (window.ThayaCart) {
      var p = window.ThayaCart.addFromForm(form);
      if (extras.length && p && p.then) {
        p.then(function () {
          var route = (window.THAYA && window.THAYA.routes && window.THAYA.routes.cart_add) || '/cart/add.js';
          return fetch(route, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: extras }) })
            .then(function () { return window.ThayaCart.refresh(); })
            .then(window.ThayaCart.open);
        });
      }
    } else {
      form.submit();
    }
  }
  if (form) form.addEventListener('submit', submitAdd);
  var stickyBtn = document.querySelector('[data-atc-sticky]');
  if (stickyBtn) stickyBtn.addEventListener('click', submitAdd);

  /* ---------- sticky ATC ---------- */
  var sticky = document.getElementById('thayaSticky');
  var buyRow = pdp.querySelector('.t-buy__row');
  if (sticky && buyRow && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      sticky.classList.toggle('is-show', !entries[0].isIntersecting && window.innerWidth <= 900);
    }, { rootMargin: '-90px 0px 0px 0px' }).observe(buyRow);
  }

  /* ---------- delivery estimate (business-day math) ---------- */
  var months = (window.THAYA && window.THAYA.rtl)
    ? ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر']
    : ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function addBiz(d, n) { var x = new Date(d), a = 0; while (a < n) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 5 && w !== 6) a++; } return x; }
  function addDays(d, n) { var x = new Date(d); x.setDate(x.getDate() + n); return x; }
  function fmt(d) { return d.getDate() + ' ' + months[d.getMonth()]; }
  (function renderDelivery() {
    var box = pdp.querySelector('.t-delivery');
    var minD = box ? (parseInt(box.dataset.delivMin, 10) || 10) : 10;
    var maxD = box ? (parseInt(box.dataset.delivMax, 10) || 14) : 14;
    var now = new Date(), from = addDays(now, minD), to = addDays(now, maxD);
    var r = pdp.querySelector('[data-deliv-range]'); if (r) r.textContent = fmt(from) + ' — ' + fmt(to);
    var t = pdp.querySelector('[data-deliv-today]'); if (t) t.textContent = fmt(now);
    var w = pdp.querySelector('[data-deliv-window]'); if (w) w.textContent = fmt(from) + '–' + fmt(to);
  })();

  /* ---------- modals ---------- */
  document.querySelectorAll('[data-open-modal]').forEach(function (b) {
    b.addEventListener('click', function () { var m = document.getElementById(b.dataset.openModal); if (m) m.hidden = false; });
  });
  document.querySelectorAll('[data-close-modal]').forEach(function (b) {
    b.addEventListener('click', function () { var m = b.closest('.t-modal'); if (m) m.hidden = true; });
  });
  document.querySelectorAll('.t-modal').forEach(function (m) {
    m.addEventListener('click', function (e) { if (e.target === m) m.hidden = true; });
  });

})();
